import React, { useState } from "react";
import { Button } from "../../../../shadcn/components/ui/button";
import OnboardingFormWrapper from "./OnboardingFormWrapper";

export default function OnboardingWarningBanner() {
  const [openOnboarding, setOpenOnboarding] = useState(false);
  return (
    <>
      <div className="sticky top-0 z-50 w-full bg-yellow-50 text-yellow-900 px-2 py-3 mb-4 shadow-sm">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
          <div>
            <p className="font-semibold text-sm sm:text-base md:text-lg">
              Your onboarding is incomplete
            </p>
            <p className="text-xs sm:text-sm md:text-base">
              Complete your onboarding to gain full access to the platform
              features.
            </p>
          </div>
          <Button
            onClick={() => setOpenOnboarding(true)}
            className="bg-brand-orange hover:bg-brand-orange text-white font-semibold text-xs sm:text-sm md:text-base px-4 md:px-6 py-2 h-8 rounded transition w-full sm:w-auto"
          >
            Complete Now!
          </Button>
        </div>
      </div>
      {openOnboarding && (
        <OnboardingFormWrapper
          open={openOnboarding}
          setOpen={setOpenOnboarding}
        />
      )}
    </>
  );
}
